/**
 * Full UI Tour event contract.
 *
 * The `<UITour />` component is mounted once in `src/pages/Index.tsx` and
 * exposes a "show" toggle. Any entry point — Tour Center "Full UI tour",
 * the onboarding checklist, chat command "start ui tour" — dispatches the
 * same window event to launch it.
 */

export const UI_TOUR_START_EVENT = 'ui-tour:start';

export function dispatchUiTourStart(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(UI_TOUR_START_EVENT));
}

export function subscribeUiTourStart(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(UI_TOUR_START_EVENT, cb);
  return () => window.removeEventListener(UI_TOUR_START_EVENT, cb);
}
